import * as React from "react";
import { Button, Checkbox, Classes, Intent } from "@focus/focusUI";
import "./GraphSelector.scss";
import { getSelectedDisplays } from "./models/graph";
export class GraphSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.changeSelection = (value) => () => {
            const currentlySelected = this.state.selectedDisplays.find((g) => g === value);
            if (currentlySelected) {
                this.setState({
                    selectedDisplays: this.state.selectedDisplays.filter((g) => g !== value),
                });
            }
            else {
                this.setState({
                    selectedDisplays: this.state.selectedDisplays.concat([value]),
                });
            }
        };
        this.selectAll = () => {
            let displays = [];
            this.props.config.selectorFolderList.forEach((selectors) => {
                displays = [
                    ...displays,
                    ...selectors.selectorList.map((display) => display.id),
                ];
            });
            this.setState({
                selectedDisplays: displays,
            });
        };
        this.unselectAll = () => {
            this.setState({
                selectedDisplays: [],
            });
        };
        this.displayPlot = () => {
            let displays = [];
            this.props.config.selectorFolderList.forEach((selectors) => (displays = [
                ...displays,
                ...selectors.selectorList.filter((g) => this.state.selectedDisplays.find((selected) => selected === g.id)),
            ]));
            this.props.onSelect(displays);
        };
        const displaySelected = getSelectedDisplays(this.props.config);
        this.state = { selectedDisplays: displaySelected };
    }
    render() {
        const selectorFolder = this.props.config.selectorFolderList;
        return (React.createElement("div", { className: "focusgrafos-graph_selector" },
            React.createElement("h3", { className: Classes.HEADING }, "Graphs to display"),
            React.createElement("div", { className: "focusgrafos-graph_controls" },
                this.state.selectedDisplays.length == 0 ? (React.createElement(Button, { minimal: true, text: "Select All", icon: "filter-list", onClick: this.selectAll, "data-testid": "selectAllDisplays" })) : (React.createElement(Button, { minimal: true, text: "Unselect All", icon: "filter-remove", onClick: this.unselectAll, "data-testid": "unselectAllDisplays" })),
                React.createElement(Button, { intent: Intent.PRIMARY, text: "Display Plot", icon: "timeline-line-chart", onClick: this.displayPlot, "data-testid": "displaySelectedButton" })),
            React.createElement("div", { className: "focusgrafos-graph_graphs" }, selectorFolder.map((selector) => selector.selectorList.map((display) => (React.createElement(Checkbox, { checked: this.state.selectedDisplays.includes(display.id), key: display.id, label: display.title, onChange: this.changeSelection(display.id), "data-testid": "displayCheckbox", id: display.id })))))));
    }
}
//# sourceMappingURL=GraphSelector.js.map